import { render, staticRenderFns } from "./BuilderDashboard.vue?vue&type=template&id=5a040340"
import script from "./BuilderDashboard.vue?vue&type=script&lang=js"
export * from "./BuilderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports